var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "18px",
    viewBox: "0 0 42 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Beta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Beta"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    fill: "#EE6B50",
    x: 0,
    y: 0,
    width: 42,
    height: 18,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,13 L8,5 L10.7032967,5 C11.6446934,5 12.3791182,5.18314835 12.9065934,5.54945055 C13.4340686,5.91575275 13.6978022,6.46336632 13.6978022,7.19230769 C13.6978022,7.56227291 13.5998178,7.89285569 13.4038462,8.18406593 C13.2078745,8.47527618 12.9230788,8.69413846 12.5494505,8.84065934 C13.0293064,8.94322396 13.3891929,9.16300198 13.6291209,9.5 C13.8690488,9.83699802 13.989011,10.227104 13.989011,10.6703297 C13.989011,11.4359013 13.7362663,12.0155658 13.2307692,12.4093407 C12.7252722,12.8031155 12.0091621,13 11.0824176,13 L8,13 Z M9.6043956,9.46153846 L9.6043956,11.7692308 L11.0824176,11.7692308 C11.5073281,11.7692308 11.8315007,11.6767409 12.0549451,11.4917582 C12.2783894,11.3067756 12.3901099,11.0329688 12.3901099,10.6703297 C12.3901099,10.2783863 12.2948727,9.97893876 12.1043956,9.77197802 C11.9139185,9.56501728 11.6135552,9.46153846 11.2032967,9.46153846 L9.6043956,9.46153846 Z M9.6043956,8.35164835 L10.7582418,8.35164835 C11.1868153,8.35164835 11.5164824,8.26373714 11.7472527,8.08791209 C11.9780231,7.91208703 12.0934066,7.65567934 12.0934066,7.31868132 C12.0934066,6.9487161 11.9771074,6.67582505 11.7445055,6.5 C11.5119036,6.32417495 11.1648375,6.23626374 10.7032967,6.23626374 L9.6043956,6.23626374 L9.6043956,8.35164835 Z M20.1373626,9.48351648 L16.8241758,9.48351648 L16.8241758,11.7692308 L20.6978022,11.7692308 L20.6978022,13 L15.2197802,13 L15.2197802,5 L20.6868132,5 L20.6868132,6.23626374 L16.8241758,6.23626374 L16.8241758,8.24725275 L20.1373626,8.24725275 L20.1373626,9.48351648 Z M27.3186813,6.23626374 L25.0549451,6.23626374 L25.0549451,13 L23.4505495,13 L23.4505495,6.23626374 L21.1978022,6.23626374 L21.1978022,5 L27.3186813,5 L27.3186813,6.23626374 Z M31.956044,11.2747253 L29.1483516,11.2747253 L28.6043956,13 L26.9835165,13 L29.7362637,5 L31.3791209,5 L34.1208791,13 L32.5,13 L31.956044,11.2747253 Z M29.543956,10.0164835 L31.5604396,10.0164835 L30.5714286,6.87362637 L30.5384615,6.87362637 L29.543956,10.0164835 Z",
    id: "3:6",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/Beta.d5e2af656d768bbb45dd54ddf3bf9a40.svg";
export { ForwardRef as ReactComponent };